/** Detail-header status capsule (spec §3.1): 14/900 rounded ink on tint at 22%. */
export function StatusPill({ text, tint }: { text: string; tint: string }) {
  return (
    <span className="detail-status-pill" style={{ background: `color-mix(in srgb, ${tint} 22%, transparent)` }}>
      {text}
    </span>
  );
}
